import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'highlight',
	pure: true,
	standalone: true
})
export class HighlightPipe implements PipeTransform {
	public transform (text: string | null | undefined, query: string | null | undefined): string {
		if (text == null) {
			return '';
		}

		if (query == null || query.length === 0) {
			return this.escapeHtml(text);
		}

		const normalizedText = text.toLocaleLowerCase();
		const normalizedQuery = query.toLocaleLowerCase();
		const result: string[] = [];
		let currentIndex = 0;
		let matchIndex = normalizedText.indexOf(normalizedQuery);

		while (matchIndex !== -1) {
			result.push(this.escapeHtml(text.slice(currentIndex, matchIndex)));
			result.push(`<b>${this.escapeHtml(text.slice(matchIndex, matchIndex + query.length))}</b>`);
			currentIndex = matchIndex + query.length;
			matchIndex = normalizedText.indexOf(normalizedQuery, currentIndex);
		}

		result.push(this.escapeHtml(text.slice(currentIndex)));
		return result.join('');
	}

	private escapeHtml (text: string): string {
		return text
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}
}
